import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import "./styles/pagination.css";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import {
  BrowserRouter as Router,
  
} from "react-router-dom";
import RouteComponent from "./route/RouteComponent";


function App() {
  
  return (
    <Router>
      <div className="App">
        <RouteComponent/>
      </div>
    </Router>
  );
}

export default App;
